var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09009 17.2169V14.4056C6.09007 13.6933 6.66936 13.1145 7.3869 13.11H10.0216C10.7423 13.11 11.3266 13.6901 11.3266 14.4056V17.2088C11.3266 17.8267 11.8287 18.3288 12.451 18.3333H14.2485C15.088 18.3355 15.8939 18.0059 16.4882 17.4173C17.0826 16.8287 17.4167 16.0295 17.4167 15.1961V7.21036C17.4167 6.53711 17.1161 5.89849 16.5959 5.46654L10.4894 0.618079C9.42197 -0.229971 7.89742 -0.202576 6.86161 0.683269L0.886428 5.46654C0.341679 5.88575 0.0160896 6.52627 0 7.21036V15.1879C0 16.9251 1.41843 18.3333 3.16816 18.3333H4.9246C5.22424 18.3355 5.51236 18.2188 5.72502 18.0092C5.93767 17.7996 6.05726 17.5144 6.05726 17.2169H6.09009Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.176b8eb780189b35b15c49398b46c1c2.svg";
export { ForwardRef as ReactComponent };